<template>
  <dialog-template v-model="isShownContent">

    <h4 :class="$style.title" slot="title">
      {{ $t(title) }}
    </h4>

    <div slot="content" :class="$style.content">
      <slot name="default" />

      <div :class="$style.action">
        <div :class="$style.submit">
          <simple-button @click="$emit('submit')">
            <strong>{{ $t('dialog.confirm.apply') }}</strong>
          </simple-button>
        </div>
        <div :class="$style.cancel">
          <simple-button variant="transparent" @click="$emit('cancel')">
            <strong>{{ $t('dialog.confirm.cancel') }}</strong>
          </simple-button>
        </div>
      </div>
    </div>
  </dialog-template>
</template>

<script>
import SimpleButton from 'molecules/common/SimpleButton';
import DialogTemplate from 'templates/DialogTemplate';

export default {
  name: 'ConfirmDialogTemplate',
  components: {
    SimpleButton,
    DialogTemplate,
  },
  props: {
    value: Boolean,
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isShownContent: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.isShownContent = val;
      },
    },
    isShownContent: {
      handler(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style lang="sass" module>
  .title
    +title-dialog
    color: #212121

  .content
    +base-text
    color: #212121

  .action
    margin-top: 20px
    display: flex
    flex-direction: column

    +respond-to('small')
      flex-direction: row

    +respond-to('medium')
      justify-content: space-between

    strong
      font-weight: 600
      font-size: 18px
      line-height: 18px

  .submit
    margin: 0 0 10px

    +respond-to('small')
      width: 230px
      margin: 0 20px 0 0

  .cancel
    overflow: hidden
</style>
